const getSanityVideoSource = value => {
  const [_file, id, extension] = value?.asset?._ref?.split("-") ?? []

  return `https://cdn.sanity.io/files/${process.env.GATSBY_SANITY_PROJECT_ID}/production/${id}.${extension}`
}

export default getSanityVideoSource
